var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/document-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.125 9.04036V21.957C27.125 25.832 25.1875 28.4154 20.6667 28.4154H10.3333C5.8125 28.4154 3.875 25.832 3.875 21.957V9.04036C3.875 5.16536 5.8125 2.58203 10.3333 2.58203H20.6667C25.1875 2.58203 27.125 5.16536 27.125 9.04036Z",
    stroke: "#566875",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7295 5.8125V8.39583C18.7295 9.81667 19.892 10.9792 21.3128 10.9792H23.8962",
    stroke: "#566875",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.333 16.793H15.4997",
    stroke: "#566875",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.333 21.957H20.6663",
    stroke: "#566875",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import_icon.00c2ae4233f0c0cd14e675e148d961dd.svg";
export { ForwardRef as ReactComponent };